import { useState, useEffect } from "react";
import { Sidebar, Menu, MenuItem, sidebarClasses } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { tokens } from "../../theme";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";

import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import SettingsSuggestRoundedIcon from "@mui/icons-material/SettingsSuggestRounded";
import HandymanRoundedIcon from "@mui/icons-material/HandymanRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import HealthAndSafetyRoundedIcon from "@mui/icons-material/HealthAndSafetyRounded";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";
import BackupRoundedIcon from "@mui/icons-material/BackupRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import { Diversity3, NotificationsActive, Translate } from "@mui/icons-material";
// import { FaSackDollar } from "react-icons/fa6";
import { GiTakeMyMoney } from "react-icons/gi";
import { GiMoneyStack } from "react-icons/gi";
import { FaSackDollar } from "react-icons/fa6";
import { useUser } from "../../provider/AuthProvider";

const Item = ({ title, to, icon, selected, setSelected, onClick }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const handleClick = () => {
    setSelected(to);
    if (onClick) onClick();
  };
  const menu_colors = selected === to ? "#ffffff" : "#ffffff";
  return (
    <MenuItem
      active={selected === to}
      // style={{ menu_colors }}
      onClick={handleClick}
      icon={icon}
      component={<Link to={to} />}
    >
      {/* <Link to={to} /> */}
      <Typography>{title}</Typography>
    </MenuItem>
  );
};

const SidebarItem = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const [selected, setSelected] = useState(() => {
    const path = location.pathname.split("/")[1]; // e.g., '/user' → 'user'
    return path.charAt(0).toUpperCase() + path.slice(1) || "Dashboard";
  });
  const { logout } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    // const path = location.pathname.split('/')[1];
    // setSelected(path.charAt(0).toUpperCase() + path.slice(1) || "Dashboard");
    setSelected(location.pathname);
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
  };

  return (
    <Sidebar
      collapsed={isCollapsed}
      rootStyles={{
        borderRight: "none",
        boxShadow:
          "inset -3px 0 0 rgba(255,255,255,0.05), 2px 0 10px rgba(0,0,0,0.4)",

        [`.${sidebarClasses.container}`]: {
          backgroundColor: "#0d1b2a",
        },
      }}
    >
      <Menu
        iconShape="square"
        menuItemStyles={{
          button: ({ level, active, disabled }) => {
            // only apply styles on first level elements of the tree
            if (level === 0)
              return {
                color: active ? "#0d1b2a" : "#DEDEDE", // active: dark text, inactive: light
                backgroundColor: active ? "#DEDEDE" : "#0d1b2a",
                "&:hover": {
                  backgroundColor: active ? "#DEDEDE" : "#22374D", // subtle hover on inactive
                  color: active ? "#0d1b2a" : "#DEDEDE", // hover text color
                },
                transition: "all 0.2s ease",
                borderRadius: "8px",
                margin: "0px 8px",
                padding: "10px 16px",
              };
          },
        }}
      >
        <Box display="flex" justifyContent="right" alignItems="right">
          <IconButton
            onClick={() => setIsCollapsed(!isCollapsed)}
            style={{ color: colors.grey[600] }}
          >
            <MenuOutlinedIcon />
          </IconButton>
        </Box>
        <Box mb="25px">
          <Box display="flex" justifyContent="center" alignItems="center">
            <img
              alt="main-logo"
              width="70px"
              height="70px"
              src={`../../assets/icons/main-logo-blue.png`}
              style={{ cursor: "pointer" }}
            />
          </Box>
        </Box>
        <Box paddingLeft={isCollapsed ? undefined : "10%"}>
          <Item
            title="Dashboard"
            to="/"
            icon={<DashboardRoundedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Reports"
            to="/report"
            icon={<InsertChartOutlinedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Compound"
            to="/compound"
            icon={<ApartmentRoundedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="CMT Management"
            to="/cmt"
            icon={<Diversity3 sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="User Management"
            to="/user"
            icon={<PeopleAltRoundedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          {/* <Item
            title="Financials"
            to="/financial"
            icon={<FaSackDollar size={26} />}
            selected={selected}
            setSelected={setSelected}
          /> */}
          <Item
            title="Subscription"
            to="/subscription"
            icon={<ReceiptLongRoundedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Notification"
            to="/notification"
            icon={<NotificationsActive sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Translations"
            to="/translations"
            icon={<Translate sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="System Settings"
            to="/setting"
            icon={<SettingsSuggestRoundedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Issue Management"
            to="/issue"
            icon={<HandymanRoundedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Activity Logs"
            to="/logs"
            icon={<HistoryRoundedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="System Health"
            to="/health"
            icon={<HealthAndSafetyRoundedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Security"
            to="/security"
            icon={<SecurityRoundedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          />
          {/* <Item
            title="Backup/Restore"
            to="/backup"
            icon={<BackupRoundedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
          /> */}
          <Item
            title="Logout"
            to={null}
            icon={<LogoutRoundedIcon sx={{ fontSize: 26 }} />}
            selected={selected}
            setSelected={setSelected}
            onClick={handleLogout}
          />
          {/* <Item
            title="User"
            to="/user"
            icon={<PeopleOutlinedIcon  fontSize="large" />}
            selected={selected}
            setSelected={setSelected}
          /> */}
          {/* <Item
            title="Compound"
            to="/compound"
            icon={<Diversity3OutlinedIcon  fontSize="large" />}
            selected={selected}
            setSelected={setSelected}
          /> */}
          {/* <Item
            title="Property"
            to="/property"
            icon={<HouseOutlinedIcon  fontSize="large" />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Subscriptions"
            to="/subscription"
            icon={<CardMembershipOutlinedIcon  fontSize="large"  />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Notification"
            to="/notification"
            icon={<NotificationsActiveOutlinedIcon  fontSize="large" />}
            selected={selected}
            setSelected={setSelected}
          /> */}
          {/* <Item
            title="Logout"
            to={null}
            icon={<ExitToAppOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
            onClick={handleLogout}
          /> */}
        </Box>
      </Menu>
    </Sidebar>
  );
};

export default SidebarItem;
